import { SkillAndCertification } from '../types/interfaces';

export const AttainmentTemplate: SkillAndCertification = {
  id: 0,
  name: '',
  shortName: '',
  description: '',
  duration: false
};
